import React from 'react';
import { useParams } from 'react-router';

import { url } from 'helpers';
import { useInvoiceBasicQuery } from 'hooks/queries';
import { SinglePage } from 'components/layout';

import View from './View';

const InvoicePaymentPage = () => {
  const params = useParams();

  const invoiceQuery = useInvoiceBasicQuery(params.displayId as string);

  return (
    <SinglePage
      query={invoiceQuery}
      returnUrl={url.toDashboard()}
      render={(invoice) => <View invoice={invoice} />}
    />
  );
};

export default InvoicePaymentPage;
